<div class="block mx-auto modal-box languages-box">
  <div class="modal1" id="modal-languages">
    <div class="p-20">
      <div class="modal-header">
         <h4 class="modal-title">{{ 'Region & Language' | translate }}</h4>
         <button title="Close (Esc)" type="button" class="close-title" (click)="onCloseDialog()" [innerHTML]="svg.closeIcon | safeHtml"></button>
      </div>
      <!-- BEFORE LOGIN -->
      <ng-container *ngIf="isLoggedIn === false; else elseAfterLogin">
        <div class="row languages-country" *ngFor="let item of availableCountryAndLanguages[currentDomain] | keyvalue: returnZero">
          <div>
            <img src="/assets/images/language/{{ item.key }}.png">
          </div>
          <div>
            <h6>{{ $any(item.value).name | translate }}</h6>
            <div class="languages-country-row">
              <ng-container *ngFor="let code of $any(item.value).languages; let i = index">
                <a (click)="setLanguage(code, $any(item.key))"
                  [ngClass]="(currentLanguageCode == code && currentCountryCode == item.key) ? 'selected' : ''">
                  {{ languages[code] }}
                </a>
              </ng-container>
            </div>
            <ng-container *ngIf="$any(item.value).languages.length == 0">
                <div class="col-12 p-0">
                    <span>{{ 'Coming soon...' | translate }}</span>
                </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- AFTER LOGIN -->
      <ng-template #elseAfterLogin>
        <div class="row languages-country">
          <div>
            <img [src]="'/assets/images/language/' + currentCountryCode + '.png'"
              [alt]="availableCountryAndLanguages[currentDomain][currentCountryCode].name + ' Flag Icon'">
          </div>
          <div>
            <h6>{{ availableCountryAndLanguages[currentDomain][currentCountryCode].name | translate }}</h6>
            <div class="languages-country-row">
              <ng-container
                *ngFor="let code of availableCountryAndLanguages[currentDomain][currentCountryCode].languages; let i = index">
                <a (click)="setLanguage(code, currentCountryCode)"
                  [ngClass]="(currentLanguageCode == code) ? 'selected' : ''">
                  {{ languages[code] }}
                </a>
              </ng-container>
            </div>
            <ng-container *ngIf="availableCountryAndLanguages[currentDomain][currentCountryCode].languages.length == 0">
                <div class="col-12 p-0">
                    <span>{{ 'Coming soon...' | translate }}</span>
                </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
